import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { requiredLabels, logoUploadInputLabels } from '@revbox/localization'
import { useCookiesContext } from '../../../../contexts/CookiesContext'

const LogoUpload = ({
    onLogoChange,
    logoInputRef,
    croppedLogoPreview,
    logoFile,
    dimensions,
    disabled = false,
    title = 'Product Logo',
    titleStyle = {},
    guidelineUrl = null,
    customTitle = null
}) => {
    const { getLanguageAbbr } = useCookiesContext()
    const lang = getLanguageAbbr()
    const labels = logoUploadInputLabels[lang]
    const dimensionsArray = Array.isArray(dimensions) ? dimensions : [dimensions]
    return (
        <div className="setting-item">
            <Row className="g-2 align-items-center">
                <Col md="2">
                    <h6 style={titleStyle}>{title}</h6>
                    <p>
                        {requiredLabels[lang] || 'Required'}
                        {dimensionsArray.map(dimension => (
                            <React.Fragment key={dimension.width}>
                                <br />
                                {`(${dimension.width} x ${dimension.height})`}
                            </React.Fragment>
                        ))}
                        {titleStyle?.width ? '' : ', JPG/PNG'}
                    </p>
                    {guidelineUrl && (
                        <p>
                            <a href={guidelineUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
                            See Guideline
                        </a>
                        </p>
                    )}
                </Col>
                <Col md>
                    <form className="file-input-form" method="post" encType="multipart/form-data" style={{ opacity: disabled ? 0.5 : 1 }}>
                        <div>
                            <input
                                type="file"
                                id="logo_upload"
                                name="image_uploads"
                                accept=".png,.jpg,.jpeg"
                                onChange={onLogoChange}
                                ref={logoInputRef}
                                style={{ opacity: 0 }}
                                disabled={disabled}
                            />
                        </div>
                        <div className="input-file-preview">
                            <label htmlFor="logo_upload">{customTitle || labels.title}</label>
                            <p className="vertical-stick"></p>
                            <p id="logo-input-placeholder">{labels.placeholder}</p>
                        </div>
                    </form>
                    {(croppedLogoPreview || logoFile) && (
                        <div className="cropped-image-preview">
                            <img src={croppedLogoPreview || logoFile} alt="Logo Preview" style={{ width: '150px', height: '150px' }} />
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    )
}

export default LogoUpload
